import type { UseTextClampProps } from '@pearlconvert/ui/components/text-clamp/text-clamp.types'

import { useEffect, useRef, useState } from 'react'

export const useTextClamp = ({
  initiallyExpanded = false,
  onToggle,
}: UseTextClampProps) => {
  const [isExpanded, setIsExpanded] = useState(initiallyExpanded)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const textRef = useRef<HTMLDivElement>(null)

  const checkOverflow = () => {
    if (textRef.current) {
      const { scrollHeight, clientHeight } = textRef.current
      setIsOverflowing(scrollHeight > clientHeight)
    }
  }

  useEffect(() => {
    checkOverflow()
    window.addEventListener('resize', checkOverflow)
    return () => window.removeEventListener('resize', checkOverflow)
  }, [isExpanded, textRef])

  const toggleExpand = () => {
    if (!isExpanded) {
      onToggle?.()
    }
    setIsExpanded(!isExpanded)
  }

  return {
    textRef,
    isExpanded,
    isOverflowing,
    toggleExpand,
  }
}
